import { render } from "./Integration.vue?vue&type=template&id=503dd2b4"
import script from "./Integration.vue?vue&type=script&lang=js"
export * from "./Integration.vue?vue&type=script&lang=js"

import "./Integration.vue?vue&type=style&index=0&id=503dd2b4&lang=css"
script.render = render

export default script